import axios from 'axios';
import InvestmentAllocationAPI from './InvestmentAllocationAPI.js';
import AccountTypeAPI from './AccountTypeAPI';
import FundingYourProductAPI from './FundingYourProductAPI.js';
import ClientsAPI from './ClientsAPI.js';
import InvestmentAllocationActions from '../actions/InvestmentAllocationActions.js';
import InvestmentAllocationHelper from '../utils/InvestmentAllocationHelper.js';
import {APIUrl} from '../constants/ApplicationConstants.js';
import ApplicationApiCallBackActions from '../actions/ApplicationApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import AdviceFeeAPI from './AdviceFeeAPI.js';
import WorkItemAPI from './WorkItemAPI';
import WorkItemHelper from '../utils/WorkItemHelper.js';
import Products from '../utils/Products.js';
import IdVerificationHelper from '../utils/IdVerificationHelper.js';
import DigitalConsentHelper from '../utils/DigitalConsentHelper.js';
import ApplicationHelper from '../utils/ApplicationHelper.js';
import {ApiResponseMessage as Message} from '../constants/InvestmentAllocationConstants.js';
import {ClientIdentificationModes} from '../constants/ApplicationConstants.js';

let ApplicationsAPI,
    request,
    submitResponse,
    CancelToken = axios.CancelToken,
    source = CancelToken.source();

function resolveApplication() {
    if (window.NOA && window.NOA.applicationId) {
        // load existing application
        ApplicationsAPI.retrieveApplication(window.NOA.applicationId);
    }
}

function retrieveApplication(applicationId) {
    const url = APIUrl.APPLICATION_RETRIEVE_URL + applicationId;

    axios.get(url)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            const application = response.data;
            if (window.NOA.userContext.isAdviser) {
                const selectMessage = Products.isInvestment(application.productId) ? Message.SELECT_MODEL_PORTFOLIO : Message.SELECT_PORTFOLIO;
                const noPortfolioMessage = Products.isInvestment(application.productId) ? Message.NO_MODEL_PORTFOLIO_SETUP : Message.NO_PORTFOLIO_SETUP;
                InvestmentAllocationAPI.getModelPortfolioList(application.productId, selectMessage, noPortfolioMessage);
                if (window.NOA.userContext.adviserCode && window.NOA.userContext.dealerCode) {
                    AdviceFeeAPI.checkAdviserFeeFlag();
                }
            }
            AccountTypeAPI.getAccountType(application.productId);

            //don't get investment options and usi list for annuities
            if (!Products.isAnnuity(application.productId)) {
                FundingYourProductAPI.getSuperFundList(application.productId);
                InvestmentAllocationAPI.getInvestmentOptionList(application.productId);
            }

            var investmentOptions = InvestmentAllocationHelper.getInvestmentOptions(application);
            if (investmentOptions && investmentOptions.length > 0) {
                InvestmentAllocationActions.receiveAllocatedInvestmentOptions(investmentOptions);
                ApplicationApiCallBackActions.sendInvestmentOptions(investmentOptions);
            }

            ApplicationApiCallBackActions.applicationRetrieveSucceeded(application);
            ApplicationHelper.postApplicationRetrieval(application);
            if (application.clientOin && !Products.isAnnuity(application.productId)) {
                ClientsAPI.getClientAccountDetails(application.productId, application.clientOin, true);
            }
            return application;
        })
        .catch((error) => {
            ApplicationApiCallBackActions.applicationRetrieveFailed(applicationId);
            throw Error('Application retrieval [applicationId: ' + applicationId + ']', error);
        });
}

function createApplication(productId, application) {
    const data = JSON.stringify(application);
    const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.APPLICATION;

    if (request && source) {
        source.cancel();
        request = void 0;
    } else {
        request = axios.post(url, data)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                const applicationId = response.data.applicationId;
                const wipId = response.data.workInProgressId;
                ApplicationApiCallBackActions.applicationSaveSucceeded(applicationId, wipId);
            })
            .catch((error) => {
                ApplicationApiCallBackActions.applicationSaveFailed(application, error);
                throw Error('Create Application', error);
            });
    }
}

function updateApplication(productId, application) {
    const data = JSON.stringify(application);
    const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.APPLICATION + application.id;

    axios.put(url, data)
        .then(ThrowIfStatusNotOk)
        .then(() => {
            ApplicationApiCallBackActions.applicationSaveSucceeded(application.id);
        })
        .catch((error) => {
            ApplicationApiCallBackActions.applicationSaveFailed(application, error);
            throw Error('Update Application [applicationId: ' + application.id + ']', error);
        });
}

function submitApplication(productId, application, consolidatedInvestmentOptions) {
    application.submitFlag = true;
    let applicationUpdatedWithKyc = IdVerificationHelper.verifyKycUpdate(application);
    let applicationUpdatedWithDC = DigitalConsentHelper.updateDigitalConsent(applicationUpdatedWithKyc);
    //if consolidatedInvestmentOptions exist use them
    if (consolidatedInvestmentOptions && consolidatedInvestmentOptions.length > 0) {
        applicationUpdatedWithDC.form.investmentAllocation.investmentOptions = consolidatedInvestmentOptions;
    }
    applicationUpdatedWithDC.submitDate = new Date().toLocaleString('en-AU', {year: 'numeric', month: '2-digit', day: '2-digit' });
    const workItemRequired = WorkItemHelper.checkIsWorkitemRequired(applicationUpdatedWithDC, productId);
    const data = JSON.stringify(applicationUpdatedWithDC);
    application.submitFlag = false;
    const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.APPLICATION;
    axios.post(url, data)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            console.log('response', response);
            const applicationId = response.data.applicationId;
            console.log('applicationId retrieved');
            const result = response.data.submitApplicationResponse;
            let accountNumber = '', oinList = '', superFirstAccountNumber = '', formList = [];
            console.log('result retrieved');
            if (result) {
                if (result.responses && result.responses.length > 0) {
                    submitResponse = result.responses;
                    console.log('submitResponse retrieved');
                    accountNumber = result.responses[0].accountNumber;
                    console.log('accountNumber retrieved');
                    oinList = result.responses[0].oinList;
                    console.log('oinList retrieved');
                    if (result.responses[1] && result.responses[1].superFirstAccount) {
                        superFirstAccountNumber = result.responses[1].accountNumber;
                        console.log('superFirstAccountNumber retrieved');
                    }
                }

                if (response.data.formList) {
                    formList = response.data.formList;
                    console.log('formList retrieved');
                }
            }

            const trn = result.transactionId;

            console.log('Successfully submitted your application with Account number: ' + accountNumber);
            console.log('Trn: ' + trn);
            console.log('ApplicationId: ' + response.data.applicationId);

            //invoke saving of backfile and filenote here
            if (workItemRequired) {
                const workItem = _.cloneDeep(application.form.workItem);
                console.log('workItem retrieved');
                const workItemPlaceHolders = response.data.submitApplicationResponse.workItemPlaceHolders;
                console.log('workItemPlaceHolders retrieved');
                if (workItem) {
                    const workItemFile = {
                        fileNote: WorkItemHelper.generateFileNoteToSubmit(workItemPlaceHolders, workItem, application.hasDigitalSignature),
                        backFile: WorkItemHelper.generateBackFileToSubmit(workItemPlaceHolders, workItem, application.hasDigitalSignature)
                    };
                    console.log('workItemFile created');
                    WorkItemAPI.sendWorkFile(productId,
                        response.data.applicationId,
                        result.responses,
                        workItemFile,
                        application.form.yourDetails);
                }
            }
            console.log('applicationSubmitSucceeded', formList);
            ApplicationApiCallBackActions
                .applicationSubmitSucceeded({
                    applicationId: applicationId,
                    accountNumber: accountNumber,
                    oinList: oinList,
                    isShellAccount: result.isShellAccount,
                    formList: formList,
                    superFirstAccountNumber: superFirstAccountNumber,
                    formModel: applicationUpdatedWithDC,
                    eAccountNumber:response.data.eAccountNumber,
                    eOin:response.data.eOin
                });
        })
        .catch((error) => {
            ApplicationApiCallBackActions.applicationSubmitFailed();
            throw Error('Submit Application [applicationId: ' + application.id + ']', error);
        });
}

function getClientIdentificationMode(queryInfo) {
    const data = JSON.stringify(queryInfo);
    const url = APIUrl.BASE_PRODUCTS_URL + queryInfo.productId + APIUrl.GET_CLIENT_IDENTIFICATION_MODE;

    axios.post(url, data)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            ApplicationApiCallBackActions.setCommSeeBackFile(response.data);
            ApplicationApiCallBackActions.setClientIdentificationMode(response.data);
        })
        .catch((error) => {
            throw Error('Client Identification Mode', error);
        });
}

function saveApplication(productId, application, clientIdentificationMode) {
    let applicationData = _.cloneDeep(application);
    applicationData.submitFlag = false;
    let {yourDetails} = applicationData.form;
    if (clientIdentificationMode.identificationMode === ClientIdentificationModes.E_FORM) {
        yourDetails.kycFlag = false;
        yourDetails.investorList && yourDetails.investorList.map(investor => investor.kycFlag = false);
    }
    if (applicationData.id) {
        // update
        updateApplication(productId, applicationData);
    } else {
        // create
        createApplication(productId, applicationData);
    }
}

ApplicationsAPI = {
    resolveApplication: resolveApplication,
    retrieveApplication: retrieveApplication,
    saveApplication: saveApplication,
    submitApplication: submitApplication,
    getClientIdentificationMode: getClientIdentificationMode,
    getSubmitResponse: function() { return submitResponse; }
};

module.exports = ApplicationsAPI;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/ApplicationsAPI.js